import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../lib/utils';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onClick: () => void;
}
export const AccordionItem = ({
  title,
  children,
  isOpen,
  onClick
}: AccordionItemProps) => {
  return <div className="border-b border-slate-200 last:border-0" data-id="element-228">
      <button onClick={onClick} className="flex w-full items-center justify-between py-4 text-left text-lg font-medium text-slate-900 transition-all hover:text-blue-600" data-id="element-229">
        {title}
        <ChevronDown className={cn('h-5 w-5 text-slate-500 transition-transform duration-200', isOpen && 'rotate-180 text-blue-600')} data-id="element-230" />
      </button>
      <AnimatePresence initial={false} data-id="element-231">
        {isOpen && <motion.div initial="collapsed" animate="open" exit="collapsed" variants={{
        open: {
          opacity: 1,
          height: 'auto',
          marginBottom: 16
        },
        collapsed: {
          opacity: 0,
          height: 0,
          marginBottom: 0
        }
      }} transition={{
        duration: 0.3,
        ease: [0.04, 0.62, 0.23, 0.98]
      }} data-id="element-232">
            <div className="text-slate-600 leading-relaxed" data-id="element-233">{children}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};